import { render, staticRenderFns } from "./PendingReview.vue?vue&type=template&id=5714329a&"
import script from "./PendingReview.vue?vue&type=script&lang=js&"
export * from "./PendingReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports